import { useCallback, useEffect, useState } from 'react';

import { Button, SheetBody, SheetFooter, DefaultSheet, SimpleAlert } from 'twyne-new.ui';

import { useGlobalStore } from '@Stores/global';

export default function AppRefreshAlertModal() {
  const { versionControl: { timestamp, updated, setDelay, DEFAULT_DELAY, NOT_NOW_DELAY } } = useGlobalStore();
  const [toggle, setToggle] = useState(false)

  useEffect(() => {
    setToggle(!updated)
  }, [timestamp, updated])

  const handleRefresh = useCallback(() => {
    window.location.reload()
  }, [])

  const handleNotNow = useCallback(() => {
    setToggle(false)
    setDelay(NOT_NOW_DELAY)
  }, [setDelay, NOT_NOW_DELAY])

  const handleClose = useCallback(() => {
    setToggle(false)
    setDelay(DEFAULT_DELAY)
  }, [setDelay, DEFAULT_DELAY])

  return <DefaultSheet
    title='App needs updating'
    trigger={<span className='hidden'></span>}
    wrapperProps={{ open: toggle, onOpenChange: handleClose }}
  >
    <SheetBody>
      <SimpleAlert className='text-md! text-center'>
        You haven't refreshed the page for a while, and in the meantime we have released a new version of the Path web application. <strong>Please Refresh the page to load the latest version.</strong>
      </SimpleAlert>
    </SheetBody>
    <SheetFooter>
      <Button variant='ghost' onClick={handleNotNow}>
        Not Now
      </Button>
      <Button color="accent" onClick={handleRefresh}>
        Refresh
      </Button>
    </SheetFooter>
  </DefaultSheet>
}
